import { Link } from "react-router-dom";
import { Flame, CheckCircle2, Video, ArrowRight } from "lucide-react";

/**
 * Item #4 — Make Readiness visible, not described.
 *
 * Tiny illustrative widget that shows the three signals Readiness Data
 * is built on: practice streak, completed assignments, tape readiness.
 * Values are static demo numbers — this is a visual proof tile on the
 * logged-out hub, not a live data surface.
 */
const TILES = [
  { icon: Flame,         label: "Practice streak",  value: "12 days", tint: "text-orange-500" },
  { icon: CheckCircle2,  label: "Assignments",       value: "8 / 10",  tint: "text-emerald-500" },
  { icon: Video,         label: "Tape readiness",    value: "84 / 100", tint: "text-primary" },
] as const;

export default function ReadinessSnapshot() {
  return (
    <div className="mb-8 rounded-2xl border border-border bg-card/60 backdrop-blur p-5">
      <div className="flex items-center justify-between mb-3">
        <div>
          <p className="text-[11px] font-semibold uppercase tracking-[0.16em] text-primary">Readiness Data</p>
          <p className="text-sm font-semibold text-foreground leading-tight">
            The daily signal that a student is callback-ready.
          </p>
        </div>
        <Link
          to="/readiness"
          className="hidden sm:inline-flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground"
        >
          How it works
          <ArrowRight className="h-3 w-3" />
        </Link>
      </div>
      <div className="grid grid-cols-3 gap-2">
        {TILES.map((t) => {
          const Icon = t.icon;
          return (
            <div key={t.label} className="rounded-lg border border-border/70 bg-background px-3 py-2.5">
              <div className="flex items-center gap-1.5 mb-1">
                <Icon className={"h-3.5 w-3.5 " + t.tint} />
                <span className="text-[10px] uppercase tracking-wide text-muted-foreground truncate">
                  {t.label}
                </span>
              </div>
              <p className="text-sm md:text-base font-semibold tabular-nums">{t.value}</p>
            </div>
          );
        })}
      </div>
      <p className="mt-3 text-[11px] text-muted-foreground">
        Practice activity, completed assignments, and coach-reviewed tapes — scored in one place.
        Visible to coaches, parents, and (with permission) casting teams.
      </p>
    </div>
  );
}